<template lang="html">
  <transition>
    <div v-if="visible" class="modal" @click.self="$emit('close')">
      <div class="container">
        <h1 :style="{ fontSize: `${fontSize}px`}">~ {{newTodo}}</h1>
        <div class="inputs">
          <TodoInput v-model="newTodo" key="todoInput" type="text" placeholder="Title"/>
          <TodoInput v-model="newTodoMotive" key="todoInputMotive" type="text" placeholder="Motivation"/>
          <TodoSelect v-model="category" :options="options"/>
          <TodoInput v-model="dueDate" key="todoInputDueDate" placeholder="done until" type="date"/>
          <TodoInput v-model="newTodoProject" key="todoInputProject" type="text" placeholder="Project"/>
          <TodoInput v-model.number="timeExpected" key="todoInputTimeExpected" placeholder="Expected time" type="number" />
          <TodoInput v-model.number="timeNeeded" key="todoInputTimeNeeded" placeholder="Actually needed time" type="number" />
        </div>
        <footer>
          <TodoButton class="leftButton" :icon="'close'" :label="'close'" @click="$emit('close')"></TodoButton>
          <TodoButton class="rightButton" :label="todo ? 'Save' : 'Save'" :icon="'plus'" @click="handleSave"></TodoButton>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import TodoButton from '@/components/TodoButton.vue';
import TodoInput from '@/components/TodoInput.vue';
import TodoSelect from '@/components/TodoSelect.vue';
import { format } from 'date-fns';

import db from '@/db.js';

export default {
  components: {
    TodoButton,
    TodoInput,
    TodoSelect,
  },
  async created() {
    this.setTodoData(); // sets data
    try {
      await this.$store.dispatch('loadTodos'); // load all todos
    } catch (err) {
      this.$store.commit('addToast', { message: `Sorry. Your rhythms could not be imported: ${err.message}` });
    }
  },
  data() {
    return {
      showIcon: false,
      fontSize: 30,
      newTodo: '',
      newTodoProject: '',
      newTodoMotive: '',
      timeExpected: '',
      timeNeeded: '',
      category: '',
      dueDate: format(new Date(), 'yyyy-MM-dd'),
      options: ['important', 'habits', 'not-to-do'],
    };
  },
  methods: {
    async handleSave() {
      const {
        newTodo,
        newTodoProject,
        newTodoMotive,
        timeExpected,
        timeNeeded,
        category,
        dueDate,
      } = this;
      if (!newTodo) {
        this.$store.commit('addToast', { message: 'You can not save without adding a rhythm.' });
        return;
      }
      if (!this.todo) {
        this.$emit('add', {
          newTodo, newTodoProject, newTodoMotive, timeExpected, timeNeeded, dueDate: new Date(dueDate).valueOf(), category,
        });
        this.newTodo = '';
        this.hoursTotal = '';
        this.hoursWorked = '';
        this.projectName = '';
        this.newTodoMotive = '';
        this.newTodoProject = '';
        this.dueDate = '';
        this.category = '';
        this.$store.commit('addToast', { message: 'Your rhythm has been added.' });
      } else {
        this.$emit('update', {
          text: newTodo, newTodoProject, newTodoMotive, timeExpected, timeNeeded, dueDate: new Date(dueDate).valueOf(), category,
        });
        this.$store.commit('addToast', { message: 'Your rhythm has been edited.' });
      }
    },
    async setTodoData() {
      if (!this.todo) return;
      const {
        text, project, motive, timeExpected, timeNeeded, dueDate, category,
      } = this.todo;

      if (project) {
        const { name } = await db.projects.get(project);
        this.newTodoProject = name;
      }
      if (motive) {
        const motiveData = await db.motives.get(motive);
        this.newTodoMotive = motiveData.text;
      }
      this.newTodo = text;
      this.timeExpected = timeExpected;
      this.timeNeeded = timeNeeded;
      this.dueDate = format(new Date(dueDate), 'yyyy-MM-dd');
      this.category = category;
    },
  },
  props: {
    title: String,
    visible: Boolean,
    icon: String,
    label: String,
    todo: Object,
    lists: String,
    id: Number,
  },
  watch: {
    todo(newValue) {
      if (newValue) this.setTodoData();
      else {
        this.newTodo = '';
        this.newTodoMotive = '';
        this.newTodoProject = '';
        this.timeExpected = '';
        this.timeNeeded = '';
        this.dueDate = '';
        this.category = '';
      }
    },
  },
};
</script>

<style lang="stylus" scoped>

@require '../assets/styles/breakpoints'

.modal
  filter: drop-shadow(2px 2px 8px rgba(67, 249, 206, 1))
  position: fixed
  top: 0
  margin-top: 50px
  left: 0
  right: 0
  bottom: 0
  z-index: 11
  display: flex
  justify-content: center

  @media $tablet
    left: auto
    margin-top: 80px

  &.v-enter-active,
  &.v-leave-active
    transition: opacity 350ms ease

    &.v-enter-active .container,
    &.v-leave-active .container
      transition: transform 350ms ease

    &.v-enter,
    &.v-leave-to
      opacity: 0

      &.v-enter .container,
      &.v-leave-to .container
        transform: translateY(2rem)

  .container
    background-image: radial-gradient(farthest-side at 100% 55%, rgba(255,0,0,0), rgba(255,191,204,0.3)0%, rgba(255,0,0,0)40%), radial-gradient(farthest-side at 80% 40%, rgba(255,0,0,0), rgba(120,108,254,0.5)0%, rgba(255,0,0,0)40%), radial-gradient(closest-side at 30% 18%, rgba(255,0,0,0), rgba(120,108,254,0.5)0%, rgba(255,0,0,0)40%), radial-gradient(closest-side at 20% 15%, rgba(255,0,0,0), rgba(0,209,255,0.3)0%, rgba(255,0,0,0)40%), radial-gradient(farthest-side at 10% 105%, rgba(255,0,0,0), rgba(133,244,194,0.3)0%, rgba(255,0,0,0)40%), radial-gradient(farthest-side at 30% 115%, rgba(255,0,0,0), rgba(120,108,254,0.5)0%, rgba(255,0,0,0)40%)
    background-color: black
    color: white
    width: 100%
    max-width: 640px
    border-radius: 2px
    font-family: futura-pt, sans-serif
    font-weight: 400;
    font-style: normal
    text-transform: uppercase

    @media $desktop
      max-width: 540px
      min-width: 440px

    @media $tablet
      max-width: 440px
      min-width: 380px

    button
      margin-left: auto
      background-color: black
      color: white
      border: none
      border-radius: 50%
      cursor: pointer
      font-family: futura-pt, sans-serif
      font-weight: 400;
      font-style: normal
      font-size: 16px
      text-transform: uppercase
      padding: 10px
      padding-right: 15px
      padding-left: 5px
      border-radius: 2px
      display: inline-flex
      align-items: center
      bottom: 0
      margin-bottom: 20px

      .label
        width: 20px
        height: 20px
        margin-right: 20px

      &:focus
        color: #C9D9D6
        background-color: transparent
        border: none
        outline: none
        border: solid 0.5px white

      &:active
        color: #C9D9D6
        background-color: transparent
        border: none
        outline: none
        border: solid 0.5px white

      &:hover
         color: #C9D9D6
         background-color: transparent
         border: none
         outline: none
         border: solid 0.5px white

    .leftButton
      position: absolute
      display: inline-flex
      align-items: center
      left:0
      color: white
      margin-left: 30px
      bottom: 20px
      background-color: black
      border-radius: 2px
      border-top: solid 0.5px white
      border-bottom: solid 0.5px white
      font-family: futura-pt, sans-serif
      font-weight: 400;
      font-style: normal
      text-transform: uppercase
      font-size: 16px
      >>> .icon
        width: 15px
        height: 15px

    .rightButton
      position: absolute
      right:0
      margin-right: 30px
      bottom: 20px
      display: inline-flex
      align-items: center
      color: white !important
      background-color: black
      border-radius: 2px
      font-family: futura-pt, sans-serif
      font-weight: 400;
      font-style: normal
      text-transform: uppercase
      font-size: 16px
      border-top: solid 0.5px white
      border-bottom: solid 0.5px white
      >>> .icon
        width: 15px
        height: 15px

    h1
      font-family: operetta-8, serif
      font-weight: 700
      font-style: normal
      text-transform: lowercase
      text-align: left
      font-size: 30
      margin-top: 25px
      margin-left: 30px !important
      padding-left: 0px !important
      margin-bottom: 20px
      padding-top: 0px !important
      overflow: hidden
      text-overflow: ellipsis

      @media $desktop
        margin-top: 70px
        margin-bottom: 23px


</style>
